<template>
  <div id="app" v-bind:class="browserName">
    <router-view></router-view>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid';

  /**
   * 同一セッション内のタブを指定msごとにカウントする
   * @type {number}
   */
  const TAB_COUNT_INTERVAL_TIME = 1000;
  /**
   * 同一セッション内のタブを指定msごとにカウントする
   * @type {number}
   */
  const TAB_COUNT_RELEASE_TIME = 800;

  export default {
    name: "App",
    data() {
      return {
        browserName: null,
        tabCountInterval : null,
      }
    },
    beforeMount() {
      window.addEventListener("beforeunload", this.onClosedTab);
      window.addEventListener("unload", this.onClosedTab);
      this.onOpenTab();
    },
    beforeDestroy() {
      window.removeEventListener("beforeunload", this.onClosedTab);
      window.removeEventListener("unload", this.onClosedTab);
    },
    created() {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
        this.browserName = 'ie-browser';
      } else if (userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1) {
        this.browserName = 'mac-safari-browser';
      }
    },
    methods: {
      /**
       * タブを開いた際、タブ識別IDとタブの状態、開いているタブ数をセッションストレージに記録する
       * ※複数タブを制限する対応
       */
      onOpenTab() {
        sessionStorage.tabState = 'open';
        if (sessionStorage.tabID === undefined || sessionStorage.tabID === null || sessionStorage.tabState !== 'open') {
          sessionStorage.tabID = uuidv4();
        }

        // 同一セッション内のタブを指定msごとにカウントする
        this.tabCountInterval = setInterval(this.tabCounter, TAB_COUNT_INTERVAL_TIME);
      },
      /**
       * タブを閉じる際、タブの状態を閉じたことをセッションストレージに記録する
       * ※複数タブを制限する対応
       */
      onClosedTab() {
        sessionStorage.tabState = 'close';
        sessionStorage.tabCount--;
        clearInterval(this.tabCountInterval);
      },
      /**
       * 同一セッション内のタブをカウントする。
       * ※1000msごとにカウントして、800msごとにカウントをリリースしカウントしているタブ数を1に保つ。
       * ただしウィンドウ・タブ数が2つ増えると時間が被っている時間があるのでそれで重複を検知する
       */
      tabCounter() {
        if (sessionStorage.tabCount === undefined || sessionStorage.tabCount === null) {
          sessionStorage.tabCount = 0;
        }
        sessionStorage.tabCount++;

        setTimeout(function () {
          sessionStorage.tabCount--;
        }, TAB_COUNT_RELEASE_TIME);
      },
      /**
       * ルーティング先のメタタグを書き換える
       * @param to
       */
      changeRouteMeta: function (to) {
        // メタ：robotsのnoindex,indexを切り替える（トップとシミュレーションと規約類のみindexにする）
        document
            .querySelector("meta[name='robots']")
            .setAttribute('content', to.meta.robots ?? 'noindex');
      },
    },
    watch: {
      '$route': function (to, from) {
        this.changeRouteMeta(to);
      }
    }
  }
</script>

<style lang="scss">
  * {
    touch-action: manipulation;
  }

  .ui-corner-all {
    max-width: 100%;
  }

  @import "src/assets/scss/utility.scss";

</style>
